module.exports = __webpack_public_path__ + "static/media/message.64d95859.svg";